function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @file 如果页面被嵌入在客户端中，需要从当前页面公共参数中的提取特定参数，后续哈勃日志上报中对应的字段都上报为客户端的参数, 可能的影响面 高途、途途、精品、公考等内嵌的h5页面
 * https://wiki.baijia.com/pages/viewpage.action?pageId=160671215
 * @author leibin@baijia.com
 */
import { isInGaoTuApp } from './env';
import { parse as parseQuery } from './json';
import cookie from './cookie';
/**
 * 判断对象不为空
 * @param {Object} obj js对象
 * @returns boolean 对象不为空
 */

export function isPlainObj() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(obj).length > 0;
} // 上报的参数与客户端公参的映射

var haboAppParamMap = {
  habo_did: 'habo_did',
  p_cuid: 'p_cuid',
  app_version: 'version',
  app_terminal: 'p_app_terminal',
  device_os: 'osname',
  app_channel: 'p_channel',
  name: 'biz_name',
  device_platform: 'dm',
  did: 'did',
  app_type: 'app_type'
};
export var commonParamsFromApp = {};

if (isInGaoTuApp) {
  try {
    if (location.search) {
      var queryObj = parseQuery(location.search.slice(1));

      if (isPlainObj(queryObj)) {
        // entries 暂无兼容性问题
        // https: //developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7
        Object.entries(haboAppParamMap).forEach(function (kv) {
          var _kv = _slicedToArray(kv, 2),
              reportKey = _kv[0],
              commonAppKey = _kv[1];

          queryObj[commonAppKey] && (commonParamsFromApp[reportKey] = queryObj[commonAppKey]);
        }); // 如果是在客户端，用于覆盖掉h5哈勃的gid, 后期都会统一成p_cuid

        var newGID = queryObj.habo_did || queryObj.p_cuid;

        if (newGID) {
          commonParamsFromApp.gid = newGID;
          commonParamsFromApp.did = newGID;
          commonParamsFromApp.device_id = newGID;
          cookie.set('GID', newGID, {
            path: '/',
            // 一年时间
            end: 31536000
          });
        }
      }
    }
  } catch (e) {
    console.error('parse commonParamsFromApp', e);
  }
}